import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue.extend({
  name: 'WeveGenericLabel',
  functional: true,
  render(h, { data, children }) {
    return h(
      'span',
      mergeData(data, {
        staticClass: 'text-sm text-light dark:text-dark',
      }),
      children,
    )
  },
})
